import React from 'react';


export const Spark = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/spark.png')} />
    )
};
